import { useState } from "react";
import type { KeyboardEvent, RefObject } from "react";
import {
  handleDownKeypress,
  handleEnterKeypress,
  handleTabKeypress,
  handleUpKeypress
} from "../utils/keyEvents";

/** Keyboard event as delivered by React's `onKeyDown` on any element. */
export type DropdownKeyEvent = KeyboardEvent<HTMLElement>;

export const useFocusedDropdownIndex = (
  inputRef: RefObject<HTMLElement | null>,
  choices: { readonly length: number },
  onEnterKeyPress: (event: DropdownKeyEvent, focusedIndex: number) => void,
  onTabKeyPress: (event: DropdownKeyEvent) => void
) => {
  const [focusedIndex, setFocusedIndex] = useState(0);
  const onKeyPress = (event: DropdownKeyEvent) => {
    handleUpKeypress(event, () => {
      if (focusedIndex === 0) {
        inputRef.current?.focus();
      } else {
        setFocusedIndex(focusedIndex - 1);
      }
    });
    handleDownKeypress(event, () => {
      if (focusedIndex !== choices.length) {
        setFocusedIndex(focusedIndex + 1);
      }
    });
    handleEnterKeypress(event, () => onEnterKeyPress(event, focusedIndex));
    handleTabKeypress(event, onTabKeyPress);
  };

  return {
    focusedIndex,
    setFocusedIndex,
    onKeyPress
  };
};
